import React from 'react';
import '../css/SystemIntegrator.css';
import IconButton from '@mui/material/IconButton';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AddIcon from '@mui/icons-material/Add';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import Loader from './Loader';
import AddOTABetaUpdated from './OtaAddNew';

class OtaUpdatesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updatesData: [],
      loader: true,
      modalIsOpenAddSI: false, // control slider
    };
  }

  componentDidMount() {
    this.fetchOtaUpdates();
  }

  fetchOtaUpdates = () => {
    this.setState({ loader: true });
    const tokenStored = `Token ${localStorage.getItem('token')}`;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': tokenStored,
      'X-CSRFToken': localStorage.getItem('csrftoken'),
    };

    fetch('/cloud/ota-update/', { method: 'GET', headers })
      .then((response) => {
        if (response.status === 403) {
          localStorage.clear();
          window.location.href = '/session-timeout';
        } else {
          return response.json();
        }
      })
      .then((data) => {
        this.setState({
          updatesData: Array.isArray(data) ? data : [],
          loader: false
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ updatesData: [], loader: false });
      });
  };

  downloadFile = (url) => {
    window.open(url, '_blank');
  };

  openAddOTASlider = () => {
    this.setState({ modalIsOpenAddSI: true });
  };

  closeAllModal = () => {
    this.setState({ modalIsOpenAddSI: false });
    this.fetchOtaUpdates(); // refresh list after adding
  };

  render() {
    const { loader, updatesData, modalIsOpenAddSI } = this.state;

    return (
      <React.Fragment>

        {loader && <Loader />}

        {/* Add OTA Button (Top Right) */}


        {/* OTA Updates Table */}
        <div className="pointer" style={{ width: '100%', padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <h2 style={{ color: '#888888' }}>OTA   Updates</h2>
            <div className="buttonContent" 
              style={{
                // display: 'flex',
                // justifyContent: 'flex-end',
                // padding: '2px 40px 2px 40px',
                backgroundColor: 'white',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                marginBottom:'10px',
                // borderRadius: '20px',
              }}
            >
              <IconButton
                sx={{
                  color: '#F08100',
                  fontSize: 40,
                  backgroundColor: 'transparent',
                  '&:hover': { backgroundColor: 'transparent' },
                  '&:focus': {
                    outline: 'none',
                    border: 'none',
                    backgroundColor: 'transparent',
                  },
                }}
                aria-label="add"
                onClick={this.openAddOTASlider}
              >
                <AddIcon sx={{ fontSize: 30 }} />
              </IconButton>
              <span
                style={{
                  color: '#888888',
                  fontSize: '10px',
                  fontWeight: '600',
                  alignSelf: 'center',
                }}
              >
                ADD OTA
              </span>
            </div>
          </div>
          <table className="table">
            <thead
              className="tableHeaderColor"
              style={{ backgroundColor: '#f5f5f5' }}
            >
              <tr>
                <th style={styles.header}>S.No</th>
                <th style={styles.header}>Version</th>
                <th style={styles.header}>Description</th>
                <th style={styles.header}>Instructions</th>
                {/* <th style={styles.header}>Token</th> */}
                <th style={styles.header}>Download Package</th>
                <th style={styles.header}>Download Documentation</th>
              </tr>
            </thead>
            <tbody>
              {updatesData.length > 0 ? (
                updatesData.map((update, index) => (
                  <tr key={update.id || index}>
                    <td style={styles.cell}>{index + 1}</td>
                    <td style={styles.cell}>{update.version}</td>
                    <td style={styles.cell}>{update.description}</td>
                    <td style={styles.cell}>{update.instructions}</td>
                    {/* <td style={styles.cell}>{update.token}</td> */}
                    <td style={styles.cell}>
                      <IconButton
                      aria-label='download package'
                        onClick={() => this.downloadFile(update.package_path)}
                        sx={{ color: '#2980B9' }}
                      >
                        <FileDownloadIcon />
                      </IconButton>
                    </td>
                    <td style={styles.cell}>
                      <IconButton
                      aria-label='download documentation'
                        onClick={() => this.downloadFile(update.document_path)}
                        sx={{ color: '#2980B9' }}
                      >
                        <FileDownloadIcon />
                      </IconButton>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={styles.cell} colSpan="6">
                    No OTA updates found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Add OTA Slider */}
        {modalIsOpenAddSI && (
          <AddOTABetaUpdated
            activeModal={true}
            closeAllModal={this.closeAllModal}
          />
        )}
      </React.Fragment>
    );
  }
}

const styles = {
  header: {
    fontSize: '12px',
    textAlign: 'center',
    verticalAlign: 'middle',
    color: '#000',
    fontWeight: 'bold',
  },
  cell: {
    fontSize: '12px',
    textAlign: 'center',
    verticalAlign: 'middle',
    wordBreak: 'break-word',
  },
};

const mapStateToProps = (state) => ({
  redux: state,
});

const mapDispatchToProps = (dispatch) => ({
  searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data }),
});

export default connect(mapStateToProps, mapDispatchToProps)(OtaUpdatesList);
